import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { User as SupabaseUser } from '@supabase/supabase-js'
import type { Usuario, Igreja } from '@/types'

interface AuthState {
  user: SupabaseUser | null
  perfil: (Usuario & { igreja?: Igreja }) | null
  isLoading: boolean
  setUser: (user: SupabaseUser | null) => void
  setPerfil: (perfil: (Usuario & { igreja?: Igreja }) | null) => void
  setIsLoading: (isLoading: boolean) => void
  logout: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      perfil: null,
      isLoading: true,
      setUser: (user) => set({ user }),
      setPerfil: (perfil) => set({ perfil }),
      setIsLoading: (isLoading) => set({ isLoading }),
      logout: () => {
        set({ user: null, perfil: null })
      },
    }),
    {
      name: 'auth-storage',
      // Persistir apenas o perfil (Supabase já persiste a sessão)
      partialize: (state) => ({
        perfil: state.perfil,
      }),
    }
  )
)
